"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.referenceResolverContextPropTypes = void 0;

var _react = require("react");

var _ReferenceResolverType = _interopRequireDefault(require("./schema/ReferenceResolverType"));

var defaultValue = undefined;
var referenceResolverContextPropTypes = {
  referenceResolverContext: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_ReferenceResolverType.default.isRequired, _react.PropTypes.func.isRequired]))
};
exports.referenceResolverContextPropTypes = referenceResolverContextPropTypes;

var _default = (0, _react.createContext)(defaultValue);

exports.default = _default;